module.exports = __webpack_public_path__ + "img/noprofile.7d956e70.png";